module.exports = __webpack_public_path__ + "static/media/supabase.3cca935b.svg";